import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "gatsby";

export const SeriesTOC = (props) => {
  const { series, post } = props;
  const showSeries = [];

  if (series?.nodes?.length > 0) {
    series.nodes.map((serie) => {
      const currentClass =
        post.frontmatter.order === serie.frontmatter.order
          ? "text-felt-500"
          : "";
      const linkClass = `block py-1 ${currentClass}`;
      return showSeries.push(
        <Link className={linkClass} to={serie.fields.permalink}>
          <strong>Part {serie.frontmatter.series.part}:</strong>{" "}
          {serie.frontmatter.title}
        </Link>
      );
    });
  }

  if (showSeries.length > 1) {
    return (
      <>
        <h3 className="font-bold mt-5 mb-2 text-sm">
          <span className="block uppercase text-xs">
            {post.frontmatter.series.name}
          </span>
          Further Reading
        </h3>
        <ul>
          {showSeries.map((part, index) => (
            <li key={`part-${index}`}>{part}</li>
          ))}
        </ul>
      </>
    );
  }
  return <></>;
};

export const SeriesNavigation = (props) => {
  const { hasMoreParts, arrows } = SeriesInfo(props);
  let navHeader = props.navHeaderText || "Continue Learning";

  if (hasMoreParts) {
    return (
      <>
        <h2 className="mt-10 mb-5 font-extrabold font-semi-expanded">
          {navHeader}
        </h2>
        <div className="pt-510 pb-24 flex flex-nowrap justify-between">
          <div>
            {arrows.prev && (
              <>
                <Link to={arrows.prev.permalink}>
                  <FontAwesomeIcon icon={faArrowLeft} className="pr-2" /> Part{" "}
                  {arrows.prev.part}: {arrows.prev.title}
                </Link>
              </>
            )}
          </div>
          <div>
            {arrows.next && (
              <>
                <Link to={arrows.next.permalink}>
                  Part {arrows.next.part}: {arrows.next.title}{" "}
                  <FontAwesomeIcon icon={faArrowRight} className="pl-2" />
                </Link>
              </>
            )}
          </div>
        </div>
      </>
    );
  }

  return <></>;
};

export const SeriesSeoTitle = (props) => {
  const { series, post } = props;

  if (series === null) {
    return post.frontmatter.seo_title || post.frontmatter.title;
  }

  const isMultiPart = IsMultiPartSeries({ series });

  return isMultiPart
    ? `${post.frontmatter.series.name} • Part ${post.frontmatter.series.part}: ${post.frontmatter.title}`
    : post.frontmatter.series.name;
};

export const IsArticleSeries = (props) => {
  const { series } = props;
  if (series === null || !series) {
    return false;
  }
  return series.nodes.length > 1 ? true : false;
};

const IsMultiPartSeries = (props) => {
  const { series } = props;
  if (series === null || !series) {
    return false;
  }
  const seriesLength = Object.keys(series.nodes).length;
  const hasMoreParts = seriesLength > 1;
  return hasMoreParts;
};

export const SeriesInfo = (props) => {
  const { post, series } = props;

  const arrows = {
    prev: null,
    next: null,
  };

  const isSeries = IsMultiPartSeries(props);
  if (!isSeries) {
    return {
      hasMoreParts: false,
      arrows,
    };
  }

  const seriesPart = post.frontmatter.series?.part;
  const seriesLength = Object.keys(series.nodes).length;
  const hasMoreParts = (seriesLength ? seriesLength : 0) > 1;
  if (hasMoreParts) {
    const curIndex = seriesPart - 1;
    if (curIndex > 0) {
      var prev = series.nodes[curIndex - 1];
      arrows.prev = {
        part: prev.frontmatter.series.part,
        permalink: prev.fields.permalink,
        title: prev.frontmatter.title,
      };
    }
    if (seriesPart < seriesLength) {
      var next = series.nodes[curIndex + 1];
      arrows.next = {
        part: next.frontmatter.series.part,
        permalink: next.fields.permalink,
        title: next.frontmatter.title,
      };
    }
  }

  return {
    hasMoreParts,
    arrows,
  };
};
